import Header from "../../../components/admin/common/Header";
import PageWrapper from "../../../components/admin/common/PageWrapper";
import Sidebar from "../../../components/admin/common/Sidebar";
import UserForm from "../../../components/admin/users/UserForm";
import { useAdmins } from "../../../hooks/useAdmins";

const AddAdminUser = () => {
  return (
    <div className="flex h-screen p-4 gap-4 bg-white overflow-hidden">
      {/* Sidebar */}
      <div className="h-full">
        <div className="sticky top-0 h-screen text-white">
          <Sidebar />
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 h-full bg-[#F3EFFF] rounded-[27px] overflow-hidden">
        <PageWrapper>
          <div className="flex flex-col h-full">
            <div className="flex-1 p-4 overflow-y-auto">
              <Header
                title="Admin Portal - Add User"
                desc="Upload and configure new gallery items"
              />
              <UserForm />
            </div>
          </div>
        </PageWrapper>
      </div>
    </div>
  );
};

export default AddAdminUser;
